module.exports = __webpack_public_path__ + "img/bg_login_3.c3b771a0.png";